import { useSolutionOrg } from '../../../config/useSolutionOrg';
import { ServiceNationSolutionOrgName } from '../../../common/constants';
import { useAppSelector } from '../../../store/hooks';
import { selectMemberInformation } from '../../../store/slices/onboardingSlice';
import { SubscriptionTier } from '../../../common/models/Subscription';
import { useOptimizelyFlag } from '../../../common/hooks/useOptimizelyFlag';
import { ServiceNationWalletFlag } from '../../../common/OptimizelyFlagsConstants';

export const useServiceNationMember = () => {
  const { solutionOrgName } = useSolutionOrg();
  const { company, solutionOrgMemberKey } = useAppSelector(selectMemberInformation);
  const { decision, isDecisionReady } = useOptimizelyFlag({
    flag: ServiceNationWalletFlag,
  });

  const isServiceNation = solutionOrgName === ServiceNationSolutionOrgName;
  const isNativeMember = !!solutionOrgMemberKey;
  const isEdgeTier =
    company?.subscription?.subscriptionTier == null ||
    company?.subscription?.subscriptionTier === SubscriptionTier.EDGE;
  const isPaidTier = !isEdgeTier;

  // SN Paid tier members who can see Wallet (flag enabled)
  const isServiceNationPaidWithAccess =
    isServiceNation &&
    isNativeMember &&
    isPaidTier &&
    isDecisionReady &&
    decision?.enabled;

  return {
    isServiceNationPaidWithAccess,
    isServiceNation,
    isEdgeTier,
  };
};
